import styled from 'styled-components'
import Check from 'src/components/form/Check'
import grabColor from 'src/utils/grabColor'

function Checkboxes({ options, value, handleOnChange, name, label, note }) {
  return (
    <div>
      <LabelWrapper>
        {label && <InputLabelFeatured>{label}</InputLabelFeatured>}
        {note && (
          <InputNote>
            {note} <NoteMetaPlaceholder />
          </InputNote>
        )}
      </LabelWrapper>
      <OptionsWrapper>
        {options.map((option, index) => {
          return (
            <Check
              key={option.value}
              checked={value?.includes(option.value)}
              value={option.value}
              name={name}
              handleOnChange={handleOnChange}
              label={option.label}
            />
          )
        })}
      </OptionsWrapper>
      <NoneOfTheAbove>
        <Check
          label="None of the above."
          checked={!value?.length}
          handleOnChange={handleOnChange}
          // defaultChecked={!value}
          value={''}
          name={name}
        />
      </NoneOfTheAbove>
    </div>
  )
}

const NoneOfTheAbove = styled.div`
  margin: 20px 0 0;
  border-top: 1px solid ${grabColor('borderContent')};
  padding: 20px 0 1rem;
`

const NoteMetaPlaceholder = styled.div`
  margin: 0 1rem 0 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.1);
`

const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 24px;
`

const OptionsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1fr;
  }
`

const InputNote = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${grabColor('detail')};
  display: flex;
  align-items: center;
  gap: 8px;
`

const InputLabelFeatured = styled.h3`
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: ${grabColor('heading')};
  margin: 0;
`

export default Checkboxes
